import React, { useRef, useEffect } from "react";
import { IconButton, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { MdCheck } from "react-icons/md";

function ImageItem({ item, setItem, editing, leftPadding, lang }) {
  const contentTextRef = useRef();

  useEffect(() => {
    if (editing) {
      contentTextRef.current.value = item.content[lang.code] || "";
    }
  }, [editing]);

  function changeSource() {
    let temp = item;
    temp.content[lang.code] = contentTextRef.current.value;
    setItem({ ...temp });
  }

  function linkAudioClip(source) {
    let temp = item;
    temp.audioClip[lang.code] = source;
    setItem({ ...temp });
  }

  function changeDescription(text) {
    let temp = item;
    if (!temp.description) temp.description = {};
    temp.description[lang.code] = text;
    setItem({ ...temp });
  }

  function changeAlignment(alignment) {
    setItem({
      ...item,
      options: {
        ...item.options,
        alignment: alignment,
      },
    });
  }

  function toggleCaptionVisibility(value) {
    setItem({
      ...item,
      options: {
        ...item.options,
        showCaption: value,
      },
    });
  }

  return (
    <div className="FW-content">
      {editing && (
        <div className="FW-content-properties" id="image">
          <div className="FW-content-source">
            <label>
              <p>Source: </p>
              <input
                ref={contentTextRef}
                type="text"
                onKeyDown={(e) => {
                  if (e.key === "Enter") changeSource();
                }}
              />
            </label>
            <IconButton color="blueButton" size="small" onClick={changeSource}>
              <MdCheck />
            </IconButton>
          </div>
          <div className="FW-attach-audio-clip">
            <label>
              <p>Audio clip: </p>
              <input type="text" value={item.audioClip[lang.code]} onChange={(e) => linkAudioClip(e.target.value)} />
            </label>
          </div>
          <div className="FW-image-caption">
            <label>
              <p
                style={{ textDecorationLine: "underline", textDecorationStyle: "dotted" }}
                title="Alt text is highly recommended for any image on the internet. If you don't plan on showing it, it can be as descriptive (ugly) as it needs to be."
              >
                Description (alt text):{" "}
              </p>
              <input
                type="text"
                value={item.description ? item.description[lang.code] : ""}
                onChange={(e) => changeDescription(e.target.value)}
              />
            </label>
          </div>
          <div>
            <label>
              <p>Show as caption?</p>
              <input
                type="checkbox"
                checked={item.options?.showCaption}
                onChange={(e) => toggleCaptionVisibility(e.target.checked)}
              />
            </label>
          </div>
          <div className="FW-image-alignment">
            <label>
              <p>Alignment: </p>
            </label>
            <ToggleButtonGroup
              exclusive
              variant="contained"
              color="blackButton"
              value={item.options?.alignment}
              size="small"
              style={{ height: "25px" }}
              onChange={(e, value) => changeAlignment(value)}
            >
              <ToggleButton disabled={item.options?.alignment === "flex-start"} value={"flex-start"}>
                L
              </ToggleButton>
              <ToggleButton disabled={item.options?.alignment === "center"} value={"center"}>
                C
              </ToggleButton>
              <ToggleButton disabled={item.options?.alignment === "flex-end"} value={"flex-end"}>
                R
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
        </div>
      )}
      {item?.content ? (
        <div
          className={`FW-image-wrapper ${editing ? "editing" : ""} ${leftPadding ? "left-padding" : ""}`}
          style={{ justifyContent: item.options?.alignment || "center" }}
        >
          <div className="embedded-image-container">
            <img
              src={item.content ? item.content[lang.code] : null}
              alt={item.description ? item.description[lang.code] : "no description"}
              draggable={false}
            />
            {item.options?.showCaption && <p>{item.description ? item.description[lang.code] : null}</p>}
          </div>
        </div>
      ) : (
        <div className="FW-content-missing-notification">[No image]</div>
      )}
    </div>
  );
}

export default ImageItem;
